module.exports = __webpack_public_path__ + "static/media/menu8.8e6cf00a.jpg";